import React from 'react'
import style from "./Property.module.css";
import { comma } from "../../utils/utils";

const Realty = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>종류</p>
        <input type="text" name={`${key_name}_kind`} data-index={index} placeholder='토지' value={data?.kind} onChange={handleInput} />
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>주소</p>
        <input type="text" name={`${key_name}_address`} data-index={index} placeholder='서울 강남구 00로 00길' value={data?.address} onChange={handleInput} />
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>현재 시세<span className={style.small}>(원) <span className={style.bold}>(실거래가)</span></span></p>
        <input type="text" name={`${key_name}_price`} data-index={index} placeholder='1,101,000,000' value={data?.price} onChange={handleInput} />
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>채무 <span className={style.small}>(담보대출, 개인 채무 등)</span></p>
        <input type="text" name={`${key_name}_debt`} data-index={index} value={data?.debt} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>(위 기재한) 부동한 형성 경위 및 부동산에 관해 알려주시고 싶으신 사항</p>
        <p className={style.tit_desc}>
          <span className={style.red}>언제(결혼 전인지 후인지, 일자), 어떠한 방식(매매, 증여, 상속, 교환 등)으로 얼마를 지급하며 형성</span>하게 된 것인지 등을 기재, 대략적으로 기재해도 무방
        </p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_etc`} data-index={index} value={data?.etc} onChange={handleInput}/>
        </div>
      </div>
    </div>
  )
}

export default Realty